<template>
  <div id="app">
    <router-view />
    <a class="homeBtb" v-if="Config.event_id == 83" href="http://2022zohx.iceriverbj.com/"
      >大会首页</a
    >
    <a class="homeBtb" v-else-if="Config.event_id == 1210" href="https://2023caa.iceriverbj.com"
      >大会首页</a
    >
    <a class="homeBtb" v-else-if="Config.event_id == 1221" href="http://2023cmdasm.iceriverbj.com/"
      >大会首页</a
    >
    <a class="homeBtb" v-else-if="Config.redirect_type && Config.redirect_type != 1" :href="Config.redirect_url">{{
      Config.icon_name
    }}</a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      id: this.$route.query.event_id,
    };
  },
  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    ...mapGetters(['Config']),
  },
  created() {
    // this.config = this.$store.state.agendaConfig;
    console.log(this.config);
  },
  watch: {
    $route: {
      handler(newval) {
        console.log(newval);
        if (newval) {
          this.id = this.$route.query.event_id;
        }
      },
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.homeBtb {
  text-align: center;
  position: fixed;
  right: 5%;
  bottom: 6%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.4rem;
  padding: 0.3rem;
  box-sizing: border-box;
  color: #fff;
  background-color: #409eff;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
}

nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
